import React from "react";
import { motion } from "framer-motion";
import influencerOne from "../assets/influencer-anita-singh.svg";
import influencerTwo from "../assets/influencer-pragya-mukherjee.svg";
import influencerThree from "../assets/influencer-shilpi.svg";
import influencerFour from "../assets/influencer-priyankka-dadwal.svg";
import star from "../assets/icons/star.svg";
import openQuote from "../assets/icons/open-quote.svg";
import endQuote from "../assets/icons/end-quote.svg";

const AutoScrollTestimonialsInfluencer = () => {
  const testimonials = [
    {
      img: influencerOne,
      name: "Anita Singh",
      position: "Lifestyle, Home Decor, Food, Skincare",
      text: `"Working with Hobo was such a smooth and amazing experience,
                super professional, easy coordination, and everything went
                perfectly."`,
    },
    {
      img: influencerTwo,
      name: "Pragya Mukherjee",
      position: "Lifestyle, Travel, Fashion",
      text: `"Such a great collaboration experience! The team is super
                professional, creative, and easy to work with. Everything felt
                effortless and well-coordinated. I highly recommend working with
                them! 💫"`,
    },
    {
      img: influencerThree,
      name: "Shilpi",
      position: "Home Finds & Decor",
      text: `"Working with Hobo was an absolute delight! Their team was super
                professional, well-coordinated, and always supportive throughout
                the collaboration. Every detail was handled smoothly, making the
                entire process effortless and enjoyable. Truly a great
                experience that I’d love to repeat!"`,
    },
    {
      img: influencerFour,
      name: "Priyankka Dadwal",
      position: "Lifestyle, Travel, Fashion",
      text: `"Loved working with this amazing team! Everything from briefing
                to campaign delivery was perfectly managed. Thank you for the
                smooth and well-coordinated collaboration 💫"`,
    },
  ];

  const TestimonialCard = ({ t }) => (
    <div className="border border-[#999999] p-4 rounded flex-shrink-0 w-[320px]">
      <div className="flex gap-[10px] items-center">
        <img
          src={t.img}
          alt={t.name}
          className="w-[41px] h-[41px] rounded-[50%]"
        />
        <div className="text-white text-left leading-[16px]">
          <p className="text-[12px] font-medium">{t.name}</p>
          <p className="text-[11px] max-w-[120px]">{t.position}</p>
        </div>
        <div className="flex ml-auto">
          {[...Array(5)].map((_, j) => (
            <img key={j} src={star} alt="star" className="w-5 h-5" />
          ))}
        </div>
      </div>
      <p className="text-[9px] font-medium text-white text-left mt-[10px]">
        {t.text}
      </p>
    </div>
  );

  return (
    <div className="relative py-[14px] w-full overflow-hidden">
      {/* Quotes positioned absolutely outside the container */}
      <img
        src={openQuote}
        className="absolute left-[-3px] top-[-5px] z-10"
        alt="open quote"
      />

      <img
        src={endQuote}
        className="absolute right-[-4px] bottom-[-5px] z-10"
        alt="end quote"
      />

      {/* Scroll container with negative margins to compensate for quote positioning */}
      <div className="flex gap-[22px] mx-[-20px]">
        <motion.div
          className="flex gap-[22px] flex-shrink-0"
          animate={{
            x: ["0%", `-${(320 + 22) * 4}px`], // Updated to 320px card width
          }}
          transition={{
            ease: "linear",
            duration: 20,
            repeat: Infinity,
            repeatType: "loop",
          }}
        >
          {[...testimonials, ...testimonials, ...testimonials].map((t, i) => (
            <TestimonialCard key={i} t={t} />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default AutoScrollTestimonialsInfluencer;
